import { StatsByCategory, StatsByCategoryMap, StateCategory } from "../types";

export function queryResultAdapter(flat: StatsByCategory): StatsByCategoryMap {
  const categoryEntries = (Object.keys(flat) as StateCategory[]).map((category) => {
    const arr = flat[category]!;

    const innerEntries = arr.map((stat) => [stat.type, stat]);

    const innerMap = Object.fromEntries(innerEntries);

    return [category, innerMap] as const;
  });

  return Object.fromEntries(categoryEntries) as StatsByCategoryMap;
}
